module.exports = __webpack_public_path__ + "img/supi_folder.fd15e610.jpg";